import TnCPage from './TnCPage'
export default TnCPage
